/**
 * * Модель получения списка таймеров
 */
export class GetTimerRecordsModel {
  /**ID задачи */
  TaskId!: number;
  /**ID исполнителя */
  PerformerId?: number;
  /**Только завершенные */
  IsOnlyEnded: boolean = true;

  constructor(obj?: Partial<GetTimerRecordsModel>) {
    Object.assign(this, obj);
  }
}
